module.exports = __webpack_public_path__ + "static/media/states.770bf917.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/states.png
// module id = 190
// module chunks = 0